import { AnimatePresence, motion } from 'motion/react';
import { forwardRef, ReactNode } from 'react';

interface BottomSlidePanelProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  className?: string;
  backdropDismiss?: boolean;
  fullWidth?: boolean;
  maxWidth?: string;
  blurBackdrop?: boolean;
}

export const BottomSlidePanel = forwardRef<
  HTMLDivElement,
  BottomSlidePanelProps
>(function BottomSlidePanel(
  {
    isOpen,
    onClose,
    children,
    className = '',
    backdropDismiss = true,
    fullWidth = false,
    maxWidth = 'max-w-md',
    blurBackdrop = true,
  },
  ref,
) {
  const handleBackdropClick = () => {
    if (backdropDismiss) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={`fixed inset-0 bg-brand-dark/50 flex items-end justify-center z-50 ${
            blurBackdrop ? 'backdrop-blur-sm' : ''
          }`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
          onClick={handleBackdropClick}
        >
          <motion.div
            ref={ref}
            className={`bg-[#1a1a1a] border-t border-white/20 ${
              fullWidth ? 'w-full' : `w-full ${maxWidth} mx-4`
            } ${className}`}
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', damping: 30, stiffness: 300 }}
            onClick={e => e.stopPropagation()}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
});
